import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
const problems = ['Tardás demasiados toques para acomodar la pelota y perdés el momento de pase', 'No levantás la cabeza a tiempo y no ves al desmarque', 'Tus tiros libres no tienen dirección ni efecto consistente', 'Te marcan fácil porque no sabés cuándo desmarcarte', 'Te falta liderazgo y no ordenás al equipo cuando el partido se complica'];
export function ProblemSection() {
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-117">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 flex flex-col items-center" data-id="element-119">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 max-w-2xl leading-tight" data-id="element-120">
            ¿Te pasa que recibis, y necesitas muchos toques y perdes tiempo
            acomodandote de mas?
          </h2>
          <p className="text-xl text-emerald-700 font-semibold" data-id="element-121">
            Ese error y estos, tienen solucion
          </p>
        </motion.div>

        <div className="grid gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-122">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-lg p-5 shadow-md flex items-start gap-4 border-l-4 border-red-600" data-id="element-123">
              <AlertCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-124" />
              <p className="text-gray-800 font-medium" data-id="element-125">{problem}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}